import React from 'react';
import { createSvgIcon } from '../utils/createSvgIcon';

export const Sale = createSvgIcon(
  () => (
    <path d="M0 10.8779C0 11.3076 0.234375 11.8936 0.546875 12.2061L8.78906 20.4482C9.53125 21.1904 10.7422 21.1904 11.4453 20.4482L19.4141 12.4795C20.1562 11.7764 20.1562 10.5654 19.4141 9.82324L11.1719 1.58105C10.8594 1.26855 10.2734 0.995117 9.84375 0.995117H1.875C0.820312 0.995117 0 1.85449 0 2.87012V10.8779ZM4.375 3.49512C5.39062 3.49512 6.25 4.35449 6.25 5.37012C6.25 6.4248 5.39062 7.24512 4.375 7.24512C3.32031 7.24512 2.5 6.4248 2.5 5.37012C2.5 4.35449 3.32031 3.49512 4.375 3.49512Z" />
  ),
  '0 0 20 22'
);
